/*
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-01-30 15:01:22
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-11-20 16:28:53
 * @FilePath: \h5-lcjc-formula\src\utils\category\Common.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 通用 */

/** 对应的标题 */
const categoryMap = {
  PlasmaOsmoticPressure: '血浆渗透压',
  HumanFun: '人体机能状态量表',
  WestHavenScore: 'West Haven分级',
  RQ: '呼吸商（RQ）',
  Morisky: 'Morisky药物依从性量表',
  NRS: '营养风险筛查（NRS-2002）',
  ACOAD: '肩锁关节脱位（ Allman 分类法）',
  ACONF: '舟骨骨折AO分型',
  DCOOF: '尺骨鹰嘴骨折Delee分型',
  FCODRF: '桡骨远端骨折Fernanda分类',
  AO: '髋臼骨折AO分型',
  DanisWeber: '踝关节Danis-Weber分类',
  EyresBrooks: '肩胛骨喙突Eyres-Brooks分型',
  EIlis: '胫骨骨折改良EIlis分类',
  COBPL: '血压水平的定义和分类标准',
  EHRAscore: '房颤相关症状分级（EHRA评分）',
  AnemiaClassification: '贫血分类',
  Acne: '痤疮分级',
  VAS: 'VAS疼痛评分',
  NewOrleansCriteria: 'New Orleans 标准',
  CriteriaOfNFIAndNFII: '神经纤维瘤NFI和NFII诊断标准',
  ParkinsonsDiseaseCriteria: '帕金森病分级标准',
  // DermatomeMapDifferent:'皮节定位图',
  FPTC: '频发复发性紧张型头痛FETTH诊断标准',
  MultipleSclerosis: '多发性硬化Poser诊断标准',
  DBPVACVV: '前庭周围性眩晕及前庭中枢性眩晕的鉴别',
  RanchoLosAmigos: 'Rancho Los Amigos认知功能分级表',
  SFAONS: '阴性症状量表（SANS）',
  SCON: '神经损伤Seddon分类',
  IETTHCriteria: '少发复发性紧张型头痛IETTH诊断标准',
  DBDACD: '神经性耳聋与传导性耳聋的鉴别',
  SunderlandClassificationOfNerveInjury: '神经损伤Sunderland分类法',
  TPCOR: '雷诺现象Taylor-Pelmear分期',
  TOOIASTT: '急性缺血性脑卒中TOSAT分型',
  DWTAEPD: '吞咽功能障碍饮水试验',
  WFNSCOSAH: '蛛网膜下腔出血（SAH）WFNS分级',
  KPOTDDCFVD: '血管性痴呆诊断标准草案要点',
  LLDOCM: '压迫性脊髓病的横向定位诊断',
  IOTOMP: '运动瘫痪类型的鉴别',
  DBTBPAFBP: '真性球麻痹和假性球麻痹的鉴别',
  SADTOOIPFC: '儿童口服铁制剂的规格及剂量表',
  CROIBPCICOAA: '儿童各年龄血苯丙氨酸理想浓度控制范围',
  DCOLPIC: '儿童铅中毒诊断标准（血铅水平）',
  CATOLCUIC: '临床常用液体成分及张力',
  SOTIM: '气管插管型号的选择',
  RBRHAABOH: 'Rh和ABO溶血病的比较',
  SalterHarrisClassification: '小儿骨骺损伤S-H分类法',
  DARTISC: '外科病儿脱水补液量和补液张力',
  ImprovedBarkovichHIEMRI: '改良Barkovich的新生儿缺氧缺血性脑病MRI分类(HIE-MRI)影像学评分',
  DDOVTOIH: '各类型颅内出血鉴别诊断',
  NMONADGA: '各胎龄新生儿神经、肌肉、成熟度',
  TAOWAERFVLF: '各种损失液每100mI所需补水和电解质液量',
  DCACGOHINHIE: '新生儿缺氧缺血性脑病HIE诊断标准和临床分度',
  ESRS: '卒中风险评分量表（ESRS）',
  ROSIERSIGLE: '卒中ROSIER量表',
  OAA_S: '警觉/镇静观察评估',
  EnergyConversion: '能量单位换算',
  Lund_Mackay: 'Lund-Mackay鼻窦炎分级',
  HAD: '医院焦虑抑郁情绪量表（HAD）',
  HormoneDoseConversion: '激素剂量换算',
  TopiramateDosageMethod: '托吡酯加量方法',
  Osserman: '重症肌无力临床分型(Osserman）',
  FFM: '去脂体重（FFM）',
  MalinasScore: '分娩Malinas评分',
  // UmbilicalLine:'脐血管置管长度',
  Ideal_height_prediction_formula: '理想身高（父母身高预测）',
  Children_bacterial_meningitis_score: '儿童细菌性脑膜炎评分',
  CSFWBCCIBC: '血性脑脊液白细胞校正公式',
  DCOIDIC: '儿童碘缺乏诊断标准（尿碘浓度）',
  DiagnosticCriteriaForNMO: 'Wingerchuk推荐视神经脊髓炎诊断标准',
  RDR: '相对剂量反应试验（维A缺乏）',
  EvidenceForHpEradication: '幽门螺杆菌（Hp）根除指征',
  DiagnosticCriteriaForCrohnsDisease: '克罗恩病诊断标准',
  ForrestClassification: 'Forrest分级',
  MayoScore: 'Mayo评分',
  TrueloveAndWittsCriteria: 'Truelove/Witts分级',
  AAST_liver_trauma_classification: 'AAST',
  Hepatitis_B_five: '乙肝五项检查',
  The_height_of_the_uterine_fundus_and_the_length_of_the_uterus_at_different_gestational_weeks: '不同妊娠周数的宫底高度及子宫长度',
  Emergency_Contraception_Pills_Dosage_and_Protocol: '紧急避孕药物剂量与方案',
  Normal_lochia_trait: '正常恶露性状',
  the_relationship_between_the_degree_of_hyperthyroidism_during_pregnancy_and_medication_dosage: '',
  fetal_maturity_test: '胎儿成熟度的监测',
  fetal_developmental_index: '胎儿发育指数',
  diagnosis_of_severe_pre_eclampsia: '重度子痫前期的诊断',
  DiagnosticCriteriaForPelvicInflammatoryDisease: '外阴盆腔炎疾病（PID）诊断标准',
  POP_Q_staging: '盆腔器官脱垂分期（POP-Q分期法）',
  TBS_classification: 'TBS分类（宫颈细胞学检查）',
  ISSVD_classification: '外阴皮肤疾病分类法（ISSVD）',
  JulianGradingMethodForVaginalCurvatureAndProtrusion: '阴道弯隆膨出Julian分级法',
  LaboratoryExaminationItemsAndResultsOfThyroidFunctionDuringPregnancy: '妊娠期甲状腺功能实验室检查项目及结果',
  KhoranaRiskScore: 'Khorana评分（化疗血栓）',
  IdentificationofRaynaudDiseaseandRaynaudPhenomenon: '雷诺病和雷诺现象鉴别',
  CrichtonRoyalBehavioralRatingScale: '克莱顿皇家医院行为量表',
  IntracranialHemorrhageVolume: '颅内出血体积计算',
  Hunt_Hess: '蛛网膜下腔出血Hunt-Hess分级',
  DCOPD: '产褥期抑郁症诊断标准',
  FCI: '漏斗胸指数',
  GCOSFOH: '肱骨髁上骨折Gartland分型',
  GCOFOTFMB: '第一掌骨基底部骨折Green分类法',
  MCOSF: '肩胛骨骨折Miller分类',
  CFSC: '跟骨骨折Sanders分类',
  Fracture_AO_classification: '肱骨近端骨折AO分类',
  ARFOCAAA: '小儿各年龄呼吸频率平均值',
  Codman_classification_of_proximal_humeral_fractures: '肱骨近端骨折Codman分类',
  ABPOCAAA: '小儿各年龄平均血压',
  criteria_of_CH: '先天性甲状腺功能减退症的诊断标准',
  TPN: '小儿肠外营养TPN推荐用量表',
  Teeth_order_in_children: '小儿出牙顺序',
  AABDOCAAA: '小儿各年龄动作及行为发育',
  AVAROHRICOAA: '小儿各年龄心率平均值及范围',
  CTOFACSIC: '小儿囟门与颅缝闭合时间',
  AEROPPD: '性早熟疾病的辅助检查结果',
  IAPOMVFCND: '新生儿常见疾病机械通气初调参数',
  RSFNPN: '新生儿肠外营养TPN推荐用量表',
  Naranjo: "诺氏（Naranjo's）评估量表",
  WHO_UMC: 'WHO-UMC因果关系分类及评估标准',
  tri_line: '气胸肺压缩程度（三线法）',
  Detsky_Index: 'Detsky指数',
  Morse: 'Morse跌倒评估量表',
  Charlson_Index: 'Charlson共病指数',
  Shizgal_Rosa: 'Shizgal-Rosa基础能耗公式',
  the_MOS_item_short_from_health_survey: '健康调查简表（SF-36）',
  FIM: '功能独立性评定量表（FIM）',
  Goldman_Index: 'Goldman评分',
  SNSS: '斯堪的纳维亚神经卒中量表（SNSS）',
  Lee_: '改良Lee评分',
  Predicting_Height_From_KH: '身高预测',
  Glucksberg: '改良Glucksberg标准',
  MAGIC: '国际联盟（MAGIC）分级标准',
  Mechanical_Ventilation: '机械通气适应症及相对禁忌症',
  NUTRIC: 'NUTRIC评分',
  POSSUMandPPOSSUM: '生理和手术严重性评分',
  International_Index_of_Erectile_Function: '国际勃起功能评分（IIEF-5）',
  SAPS_two: 'SAPSⅡ评分',
  APACHE_two: 'APACHEⅡ评分',
  MABL: '术中失血量的估算',
  Ret: '校正网织红细胞计数',
  ILinChildren: '儿童肠道长度计算',
  RPI: '网织红细胞生成指数（RPI）',
  SMARTCOP: 'SMART-COP评分',
  ADOindex: 'ADO指数',
  PisaPE: 'Pisa肺栓塞预测模型',
  PHWHOFC: 'WHO-FC肺动脉高压功能分级',
  ISTHSSCDIC: '显性弥散性血管内凝血（ISTH-DIC）',
  ISTHNONOVERTDIC: '非显性弥散性血管内凝血（ISTH-DIC）',
  PRAMSCORE: 'PRAM评分',
  PNFLRINEC: '坏死性筋膜炎风险LRINEC评分',
  FONTAINEANDRUTHERFORD: '慢性下肢缺血Fontaine/Rutherford分级',
  LVFUNCTION: '常用左室功能参数',
  PELD_score: 'PELD评分',
  ADL: '日常生活活动独立指数',
  Bado_classification_of_Montessori_fracture: '孟氏骨折Bado分型',
  Lauge_Hansen: '踝关节Lauge-Hansen分类',
  Classification_of_medial_epicondyle_fractures_of_the_humerus: '肱骨内上髁骨折分度',
  Herbert_classification_of_scaphoid_fracture: '舟骨骨折herbert分型',
  epidural_anaesthesia: '硬膜外阻滞常用局麻药浓度和剂量',
  open_fractrue: '开放性骨折（朱通伯分类）',
  open_fracture_gustilo: '开放性骨折Gustilo-Anderson分类',
  Ottawa_ankle_rules: 'Ottawa踝关节骨折诊断规则',
  ManningFetalBiophysica_MonitoringScoreAndProcessingPrinciples: 'Manning胎儿生物物理监测评分及处理原则',
  the_impact_of_commonly_used_pregnant_women_medication_on_the_fetus: '常用孕妇用药对胎儿的影响',
  MenopausalRatingScale: '更年期评定量表（MRS）',
  NugentScoringCriteriaForGramStainingOfVaginalSecretions: '阴道分泌物革兰染色Nugent评分标准',
  VbacRiskScoreForVaginalDelivery: '阴道分娩的VBAC风险评分（Flamm模型）',
  clinical_classification_of_vulvovaginal_candidiasis: '外阴阴道假丝酵母菌病（VVC）临床分类',
  clinical_manifestations_scoring_criteria_for_vulvovaginal_candidiasis: '外阴阴道假丝酵母菌病（VVC）临床表现评分标准',
  ReidColposcopicIndex: 'Reid阴道镜评分标准（RCI）',
  POP_QStagingEvaluationIndicatorPointForPelvicOrganProlapse: '盆腔器官脱垂评估指示点（POP-Q分期）',
  classification_and_classificationof_OHSS: '卵巢过度刺激综合征（OHSS）的分度与分级',
  InslerCervicalEstrogenLevelScoringMethod: 'Insler宫颈雌激素作用程度评分法',
  halfway_system: '盆底器官膨出的阴道半程系统分级法',
  the_location_and_common_diseases_of_abdominal_masses: '腹部肿块的部位和常见疾病',
  DukesClassification: '大肠癌Dukes分期',
  Rutherford_classification_of_lower_limb_arteriosclerosis_obliterans: '下肢动脉硬化闭塞症（ASO）Rutherford分类',
  ControlObjectivesOfType2DiabetesInChina: '中国2型糖尿病控制目标',
  ZDSC: '肩胛骨Zdravkovic-Damholt分型',
  SASOLDH: '腰椎间盘突出症的症状和体征',
  WYCOOF: '开放性骨折的王亦璁分类',
  TCOSI: '肩关节不稳定的Thomas分类',
  WHO_HumanSemen: '精液变量参考值（WHO）',
  OsmolalGap_serum: '渗透间隙（血清）',
  OxygenDeliveryMethodAndConcentration: '不同给氧方式与浓度',
  Lipid_unit_conversion: '血脂单位换算',
  UrineOutput: '尿量',
  VisceralTractionReaction: '内脏牵拉反应',
  NACA: 'NACA 分级',
  DeltaGap: '差值间隙与差值比',
  WaterDeficit: '缺水',
  ChillsGraded: '术后寒战分级',
  Serum_permeation_gap: '渗透间隙（血清）',
  CVC: '中心静脉导管（CVC）置管深度',
  HypertonicDehydrationRehydrationVolume: '高渗性脱水补液量',
  MEWS: '改良早期预警评分',
  MortalityInOlderAdultsAfterHospitalization: '老年人出院后死亡率',
  STRATIFY: '老年住院患者跌倒风险',
  NaCl: '低钠时补氯化钠量',
  CaO: '动脉血氧含量（CaO₂）',
  FAS_Cr_Cys: 'GFR（FAS）',
  ImprovedAndSimplified_MDRD: 'GFR（改良的简化MDRD）',
  Apfel: '成人Apfel评分',
  EPDS: 'EPDS',
  AndersonClassificationOfOpenFractures: '开放性骨折Anderson分类',
  ElbowCassebaumScoringSystem: '肘关节Cassebaum评分系统',
  DenisClassificationOfBurstFracture: '爆裂骨折Denis分型',
  FrykmanClassificationOfDistalRadiusFractures: '桡骨远端骨折Frykman分类',
  IdebergClassificationOfIntraglenoidFractures: '关节盂软骨内骨折分型',
  PerioperativeHighriskCriteria: 'ICU患者术前、术后高危标准',
  PulmonaryEmbolismSeverity: '肺栓塞严重程度与早期死亡风险',
  Caprini: 'Caprini风险评估模型',
  Diseaseactivityscorein28joints: '类风湿关节炎疾病活动性评分（DSA28）',
  Colorectal_carcinoma: '结直肠癌TNM分期',
  Soft_tissue_sarcoma_of_extremities_and_trunk: '四肢和躯干软组织肉瘤TNM分期',
  Pleural_mesothelioma: '胸膜间皮瘤TNM分期',
  Distal_bile_duct_carcinoma: '远端胆管癌TNM分期',
  Chronic_tension_type_headaches: '慢性紧张型头痛CTTH诊断标准',
  Neuroendocrine_tumors_of_the_colon_and_rectum: '结肠、直肠神经内分泌肿瘤TNM分期',
  Gastric_cancer: '胃癌TNM分期',
  Prognostic_evaluation_of_myelodysplastic_syndrome: 'MDS基于WHO分类的预后评估（WPSS）',
  Langerhans_cell_histiocytosis: '朗格汉斯细胞组织细胞增生症（LCH）临床分型',
  Knee_fracture: 'Ottawa膝关节骨折诊断规则',
  Scapholunate_instability: '舟月不稳定的分级',
  Carpal_tunnel_syndrome: '腕管综合征功能评定表',
  Perilunate_dislocation_stage: '月骨周围脱位分期',
  Posterior_dislocation_of_shoulder: '肩关节后脱位分型',
  Sacroiliac_joint_disorder: '骶骼关节病变X线分级',
  Systemic_lupus_erythematosus_activity_score: '系统性红斑狼疮活动度评分（SLEDAI）',
  Spondyloarthropathies: '脊柱关节病Amor诊断标准',
  Postpubertal_sex_cord: '睾丸青春期后生殖细胞肿瘤及恶性性索间质肿瘤TNM分期',
  Fluid_in_the_tympanum: '鼓室内膜迷路积水分级',
  bromhidrosis: '腋臭的诊断和分级法',
  HDSS: '多汗症的诊断标准',
  Pelvis_Tile_classification: '骨盆Tile分型',
  Modified_Evans_classification_of_intertrochanteric_fractures: '股骨转子间骨折改良Evans分型',
  HDSS1: '多汗症HDSS分级',
  Pyrrolysine: '吡咯赖氨酸',
  Spinal_cord_injury_Frankel_functional_class_ASIA_class: '脊髓损伤Frankel功能分级',
  Regan_classification_of_ulnar_coronoid_process_fractures_of_the_elbow: '肘关节尺骨冠状突骨折Regan分型',
  Karlsson_postoperative_efficacy_scoring_criteria: 'Karlsson术后疗效评分标准',
  Tscheme: 'Tscheme闭合伤分级',
  ASIA__: '脊髓损伤ASIA分级',
  Histidine: '组氨酸',
  TIBC: '总铁结合力',
  LBP: '脂多糖结合蛋白',
  NEUT: '中性粒细胞占比',
  ANC: '中性粒细胞计数',
  TRF: '转铁蛋白',
  TP1NP: '总Ⅰ型前胶原氨基端延长肽',
  TC: '总胆固醇',
  Na: '钠',
  BUN: '尿素氮',
  HCT: '血细胞比容',
  Blood_Platelet: '血小板',
  Folic_Acid: '叶酸',
  Folate: '叶酸盐',
  Val: '缬氨酸',
  SHBG: '性激素结合球蛋白',
  Methionine: '蛋氨酸（Met）',
  Pantothenic_Acid: '泛酸（维生素B5）',
  Glutamine: '谷氨酰胺（Gln）',
  Osteocalcin: '骨钙素（OCN）',
  Lysine: '赖氨酸',
  Fructose: '果糖',
  Gentamicin: '庆大霉素',
  Lidocaine: '利多卡因',
  Riboflavin: '核黄素（维生素B2）',
  Gamma_Light_Chain: 'γ轻链',
  p_C_telopeptides_of_type_I_collagen: 'β-胶原降解产物（Ⅰ型胶原降解产物）',
  βHCG: '游离人绒毛膜促性腺激素β亚基（游离βhCG）',
  E3: '游离雌三醇',
  lle: '异亮氨酸',
  p_AMY: '胰淀粉酶',
  ADH: '乙醇脱氢酶',
  Urea_unit_conversion: '尿素',
  RBC_UnitConversion: '红细胞',
  WBC_UnitConversion: '白细胞',
  Unit_conversion_of_common_ions: '常见物质的单位换算',
  IgE: '免疫球蛋白E（IgE）',
  IgA: '免疫球蛋白A（IgA）',
  ammonia: '血氨（NH3）',
  Methanol: '甲醇',
  albumin: '白蛋白（ALB）',
  Gastrin_unit_conversion: '胃泌素',
  estradiol: '雌二醇（E2）',
  IL_six: '白细胞介素-6（IL-6）',
  AFP: '甲胎蛋白（AFP）',
  RF: '类风湿因子（RF）',
  ethanol: '乙醇',
  Tryptophan: '色氨酸(Trp)',
  Biotin: '生物素(维生素B7)',
  Threonine: '苏氨酸(Thr)',
  Hemoglobin_A1c: '糖化血红蛋白（HbA1c）与平均血糖（eAG）的换算',
  Placental_Growth_Factor: '胎盘生长因子（PIGF）',
  Bicarbonate: '碳酸氢盐（HCO3-）',
  Ascorbic_Acid: '维生素C（抗坏血酸）',
  Total_Vitamin_D: '维生素D总量',
  Thiamine: '维生素B1（硫胺素）',
  Niacin: '维生素B3（烟酸）',
  Pyridoxine: '维生素B6（磷酸吡哆醛）',
  Tobramycin: '妥布霉素',
  Vancomycin: '万古霉素',
  '25_Hydroxyvitamin_D': '25-羟基维生素D（骨化二醇）',
  Vitamin_E: '维生素E（α-生育酚）',
  Selenocysteine: '硒代半胱氨酸（Sec）',
  C_reactive_protein: 'C-反应蛋白'
}
/** 对应的描述 */
const categoryDescMap = {
  PlasmaOsmoticPressure: '测量血浆中渗透压间隙',
  HumanFun: '评估肿瘤患者耐受化疗的能力',
  WestHavenScore: '肝性脑病临床分级',
  RQ: 'CO₂生成量与O₂消耗量的比值',
  Morisky: 'MMAS-8',
  NRS: '临床营养风险评估工具',
  EPDS: '爱丁堡产后抑郁量表',
  ElbowCassebaumScoringSystem: '定量肘关节的功能活动范围',
  Caprini: '静脉血栓风险分层',
  Diseaseactivityscorein28joints: '基于红细胞沉降率、关节情况',
  Fluid_in_the_tympanum: '根据MRI造影评估',
  bromhidrosis: 'Park和Shin分级法',
  Pelvis_Tile_classification: '骨盆骨折分类法',
  Modified_Evans_classification_of_intertrochanteric_fractures: '判断骨折的稳定性',
  HDSS1: '评估多汗的严重程度',
  Karlsson_postoperative_efficacy_scoring_criteria: '评估踝关节功能和术后疗效',
  Tscheme: '评估闭合性骨折中软组织损伤的严重度',
  ANC: '中性粒细胞绝对值',
  Unit_conversion_of_common_ions: '钾、钙、钠、镁、铜、铁、锂、锌、磷'
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Common.js